import React, { useRef, useState } from "react";
import logo from "../assets/appnest_logo.png";
import ButtonCompo from "../component/ButtonCompo";
import loginVid from "../assets/login.mp4";
import PasswordField from "../component/PasswordField";
import InputField from "../component/InputField";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AlertBox from "../component/AlertBox";
import { LinearProgress } from "@mui/material";
import axios from "axios";
import { SERVER_URL } from "../constant";
import { employeeLogin } from "../store/employeeAuth.slice";
import { reloadToggle } from "../store/reload.slice";

function EmployeeSignIn() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const alertRef = useRef(null);

  async function signin() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/login`,
        method: "post",
        data: {
          email: username,
          password: password,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        dispatch(reloadToggle());
        //changing status in redux
        dispatch(employeeLogin({ status: true }));
        navigate("/employee/dashboard");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex items-center justify-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-1/2 hidden lg:flex h-[100vh]">
          <video
            src={loginVid}
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          />
        </div>
        <div className="w-full lg:w-1/2 h-full flex flex-col justify-center items-center py-10">
          <img src={logo} className="w-[10rem] mb-[3rem]" alt="" />
          <div className="w-full flex justify-center items-center">
            <div className="w-[20rem] flex flex-col justify-center items-center">
              <div className="text-left w-full mb-5">
                <p className="text-[23px] font-semibold">Welcome Back</p>
                <span className="text-[15px] text-slate-500">
                  Please login to access your employee account.
                </span>
              </div>
              <div className="w-full space-y-5">
                <InputField
                  label="Username"
                  onChange={(e) => setUsername(e?.target?.value)}
                />
                <PasswordField
                  onChange={(e) => setPassword(e?.target?.value)}
                />
                <p className="text-center text-[13px] text-slate-500">
                  Don't remember the password? <Link className="text-blue-600 font-semibold underline" to={"/employee/forgot/password"}>Forgot Password</Link>
                </p>
              </div>
              <ButtonCompo
                variant="contained"
                className="!mt-5 w-full"
                onClick={signin}
              >
                login
              </ButtonCompo>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployeeSignIn;
